import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';   //  设置分页英文环境


//axios.defaults.baseURL = ""

/*axios.defaults.baseURL = "https://madeforchina.tuv-sud.cn/AcademyCertificateQuery" */
 /* axios.defaults.baseURL = "https://10.103.9.184:9977/IACS_Query" */
axios.defaults.baseURL = "https://madeforchina.tuv-sud.cn/IACSCertificate"




Vue.prototype.$axios = axios
//axios.defaults.withCredentials = true 

Vue.use(ElementUI, { locale })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
